const breakpoints = {
	xl: 1200,
	lg: 992,
	md: 768,
	sm: 576
};

module.exports = breakpoints;
